import { Box } from "@mui/system";
import Lottie from "lottie-react";
import groovyWalkAnimation from "../../assets/65364-loader.json";

export const FullHeightLoader = ({ position = 0 }) => {
	return (
		<Box
			sx={{
				display: "flex",
				position: "fixed",
				backgroundColor: "rgba(255, 255, 255, 0.5)",
				bottom: 0,
				right: 0,
				left: 0,

				top: 0,
				justifyContent: "center", // ✅ center horizontally
				alignItems: "center",
				zIndex: 1300,
			}}
		>
			<Lottie
				style={{ width: "200px" }}
				animationData={groovyWalkAnimation}
			></Lottie>
		</Box>
	);
};
